import Axios from "axios";

export class CatalogoService {

    getCatalogosId(id) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/catalogo/ibuscar/${id}`).then(res => res.data);
    }

    getActividades(nombre) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/catalogo/nbuscar/${encodeURIComponent(nombre)}`).then(res => res);
    }

    buscarActividadCiiu(termino) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/catalogo/ciiu/buscar-ciiu`, { params: { termino: termino } }).then(res => res.data);
    }

    getActividadesCiiu(params) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/catalogo/ciiu/lista`, { params: params }).then(res => res.data);
    }
}